import { createFileRoute } from '@tanstack/react-router';

import { SlideLibraryTemplate } from '@/features/slide-editor';

export const Route = createFileRoute('/_authenticated/slide-library/')({
  component: SlideLibraryPage,
});

function SlideLibraryPage() {
  return <SlideLibraryTemplate />;
}
